module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Death-Of-Stalin-The.526e89a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Death-Of-Stalin-The.jpg
// module id = xHyr
// module chunks = 0